export default __webpack_public_path__ + "imgs/053b47780914051651fa5f40b3c6428d.png";